module.exports = __webpack_public_path__ + "static/img/jiantou.ea85403e.png";